const CONFLICT_MESSAGE = '账号已注册，但业务账号关联遇到冲突，暂时无法登录。请联系平台客服协助处理，无需重复注册或修改密码。'

// Only display reviewed messages. Upstream errors may contain internal details.
export const getLoginError = error => {
  if (error && error.reason === 'identity_conflict') {
    return { message: CONFLICT_MESSAGE, canRetry: false }
  }
  const message = (error && error.message) || ''
  if (/state has expired|state is invalid|callback is incomplete/.test(message)) {
    return { message: '登录验证已失效，请重新登录。若刚刚完成注册，无需再次注册。', canRetry: true }
  }
  if (/Browser storage is unavailable/.test(message)) {
    return { message: '浏览器无法保存登录状态，请允许网站存储，或使用系统浏览器重新登录。', canRetry: true }
  }
  if (/Failed to fetch|NetworkError|Load failed/.test(message)) {
    return { message: '网络连接失败，请检查网络后重新登录。', canRetry: true }
  }
  return { message: '暂时无法完成登录，请重新登录。如仍无法登录，请联系平台客服，无需重复注册。', canRetry: true }
}
